import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import SignUpForm from "./SignUpForm";
import { Container } from "./styles";
import { employerSignUp } from "../../../redux/middleware/user";
import Utils from "../../../lib/utils";

const notifyUser = (notify, user) => {
  if (user.message === "You have successfully signed up") {
    Utils.setUserToken(user.auth_token);
    notify("success", user.message);
    localStorage.setItem("qcUserToken", JSON.stringify(user.auth_token));
    localStorage.setItem("qcUser", JSON.stringify(user.employer));
    window.location.href = "/payment";
  } else {
    notify("error", user.message);
  }
};

const SignUp = ({ signup, history, user, notify, pending, loggedInUser }) => {
  if (loggedInUser && loggedInUser.email) history.push("/payment");
  const checkProps = useRef(true);
  useEffect(() => {
    if (checkProps.current) {
      checkProps.current = false;
    }
  }, [user]);

  const [email, setEmail] = useState("");
  const [lname, setLname] = useState("");
  const [fname, setFname] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [shownNotification, setShownNotification] = useState(false);

  const handlePassword = (e) => setPassword(e.target.value);
  const handleEmail = (e) => setEmail(e.target.value);
  const handleCompanyName = (e) => setCompanyName(e.target.value);
  const handleConfirmPassword = (e) => setConfirmPassword(e.target.value);
  const handleFirstName = (e) => setFname(e.target.value);
  const handleLastName = (e) => setLname(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      company: { name: companyName },
      user: {
        email,
        fname,
        lname,
        password,
        confirmPassword,
      },
    };
    signup(data);
    setShownNotification(false);
  };

  if (!shownNotification && user && user.message && !pending) {
    notifyUser(notify, user);
    setShownNotification(true);
  }
  return (
    <Container>
      <SignUpForm
        handleSubmit={handleSubmit}
        handlePassword={handlePassword}
        handleConfirmPassword={handleConfirmPassword}
        handleCompanyName={handleCompanyName}
        handleEmail={handleEmail}
        handleLastName={handleLastName}
        handleFirstName={handleFirstName}
        loading={pending}
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.createUser.user,
  loggedInUser: state.createUser.user,
  pending: state.createUser.pending,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signup: (data) => employerSignUp(data),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignUp));
